export enum NumberPlatePreviewSize {
	Size20 = 20,
	Size30 = 30,
}
